import React from 'react';
import { Typography, Box } from '@mui/material';

const CaisseDetails = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Détails de la Caisse
      </Typography>
      <Typography variant="body1">
        Module de détails des caisses - En cours de développement
      </Typography>
    </Box>
  );
};

export default CaisseDetails;

